import { z } from 'zod';

/**
 * Generic error payload returned by the backend for any 4xx/5xx.
 *
 * Mapped by the backend's error-handler middleware from `HttpError` domain
 * classes. Frontend reads `error` (stable code) for logic and `message` for
 * display.
 */
export const apiErrorSchema = z.object({
  error: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ApiError = z.infer<typeof apiErrorSchema>;
